import { compose } from 'ramda';
import { connect } from 'react-redux';
import { defaultProps } from 'recompose';

import Filters from '@/components/FiltersRow';
import {
  removeFilters,
  updateFilters,
} from '@/features/locationsStatisticsPage/actions';
import { filterTypes } from '@/features/locationsStatisticsPage/filters';
import { getFilters } from '@/features/locationsStatisticsPage/selectors';

const mapStateToProps = state => ({
  filters: getFilters(state),
});

const mapDispatchToProps = { removeFilters, updateFilters };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  defaultProps({ filterTypes }),
)(Filters);
